import { render, staticRenderFns } from "./StoreProduct.vue?vue&type=template&id=35a57c96&"
import script from "./StoreProduct.vue?vue&type=script&lang=js&"
export * from "./StoreProduct.vue?vue&type=script&lang=js&"
import style0 from "./StoreProduct.vue?vue&type=style&index=0&id=35a57c96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports